var React = require('react');

function MapPinHollow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 17.4902C7.35577 17.4902 12 9.55394 12 6.24023C12 2.92653 9.31371 0.240234 6 0.240234C2.68629 0.240234 0 2.92653 0 6.24023C0 9.55394 4.64423 17.4902 6 17.4902ZM6.00012 9.23975C7.65698 9.23975 9.00012 7.8966 9.00012 6.23975C9.00012 4.58289 7.65698 3.23975 6.00012 3.23975C4.34327 3.23975 3.00012 4.58289 3.00012 6.23975C3.00012 7.8966 4.34327 9.23975 6.00012 9.23975Z","fill":"#333333"}));
}

MapPinHollow.defaultProps = {"width":"12","height":"18","viewBox":"0 0 12 18","fill":"none"};

module.exports = MapPinHollow;

MapPinHollow.default = MapPinHollow;
